package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
data class SuperAdminDashboardStatsResponse(
    val totalUsersCount: Long,
    val newUsersYesterdayCount: Long,
    val totalBusinessesCount: Long,
    val newBusinessesYesterdayCount: Long,
    val totalVenuesCount: Long,
    val venueJoinRequestsCount: Long
)

@Serializable
data class ModeratorDashboardStatsResponse(
    val venueModerationRequestsCount: Long,
    val reviewModerationRequestsCount: Long
)

@Serializable
data class VenueOwnerDashboardStatsResponse(
    val totalReviewsCount: Long,
    val unansweredReviewsCount: Long,
    val todayReviewsCount: Long,
    val todayUnansweredReviewsCount: Long
)

@Serializable
data class DashboardStatsResponse(
    val role: UserRole,
    val superAdmin: SuperAdminDashboardStatsResponse? = null,
    val moderator: ModeratorDashboardStatsResponse? = null,
    val venueOwner: VenueOwnerDashboardStatsResponse? = null
)
